module.exports = __webpack_public_path__ + "media/images/default_preview-5cf865eed92ef592c21e5026e06a9ead.png";